import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/msalConfig";
import { scheduleTokenRefresh, clearTokenRefresh } from "../utils/tokenRefresh";
import Spinner from "./Spinner";
import ChatContainerBlk from "./ChatContainerBlk";

const LoginCard: React.FC = () => {
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isCheckingSession, setIsCheckingSession] = useState(true);
  const { instance } = useMsal();
  const [loginResponse, setLoginResponse] = useState<any>(null);

  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      // Acquire token silently to get the idToken
      instance
        .acquireTokenSilent({ ...loginRequest, account: accounts[0] })
        .then((response) => {
          localStorage.setItem("idToken", response.idToken);
          setLoginResponse(response);
          scheduleTokenRefresh(instance);
        })
        .catch(() => {
          // If silent fails, still register the MSAL instance so forceTokenRefresh
          // can work if the user tries to send a message before re-authenticating
          scheduleTokenRefresh(instance);
          setLoginResponse({ account: accounts[0] });
        })
        .finally(() => {
          setIsCheckingSession(false);
        });
    } else {
      setIsCheckingSession(false);
    }

    return () => {
      clearTokenRefresh();
    };
  }, [instance]);

  const handleContinue = () => {
    setIsLoading(true);
    setMessage("");

    instance
      .loginPopup(loginRequest)
      .then((response) => {
        localStorage.setItem("idToken", response.idToken);
        setLoginResponse(response);
        scheduleTokenRefresh(instance);
      })
      .catch((error) => {
        console.error("Login error:", error);
        setMessage("Login failed. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isCheckingSession) {
    return (
      <div className="main-container">
        <Spinner variant="large-spinner" alignSpin="center-spinner" />
      </div>
    );
  }

  return (
    <React.Fragment>
      {!loginResponse ? (
        <div className="main-container">
          <div className="login-card">
            <h2 className="login-title">
              Welcome to
              <br />
              CX Perspectives
            </h2>

            <p className="login-subtitle">
              Your advanced contact centre analytics assistant
            </p>

            <p className="message-blk">{message}</p>

            <button
              className="login-button"
              onClick={handleContinue}
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner variant="small-spinner" alignSpin="center-spinner" />
              ) : (
                "Continue"
              )}
            </button>
          </div>

          <div className="login-footnote-blk">
            <p className="powered-by-blk">
              Powered BY:<span>iCXeed</span>
            </p>
          </div>
        </div>
      ) : (
        <ChatContainerBlk idToken={loginResponse?.idToken || ""} />
      )}
    </React.Fragment>
  );
};

export default LoginCard;
